// Central data for the 7 service pillars. Each entry powers /services/:slug
export const SERVICES = [
  {
    hero_position: "35% 50%",
    slug: "seo",
    n: "01",
    title: "Search Engine Optimization",
    short: "SEO",
    tagline: "Get found. Stay found.",
    intro:
      "Grow your business with SEO built for long-term success. We combine technical optimization, quality content, and authority-building strategies to increase visibility, attract qualified traffic, and generate consistent leads.",
      sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "SEO",
    titleEnd: "Framework.",
    description:
      "From technical SEO and keyword research to content creation, on-page optimization, off-page SEO, and local SEO, we build strategies that increase rankings, organic traffic, and qualified leads."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "SEO",
    accent: "Questions",
    titleEnd: "?",
    description:
      "Everything you need to know about our SEO services, timelines, pricing, reporting, and what results you can expect."
  }
},
    hero_image:
      "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/02/Gemini_Generated_Image_6az7c86az7c86az7-e1784874223831.png",
      
    portfolio_tags: ["SEO", "Technical SEO", "Content", "PR"],
    offer: [
      { t: "Technical SEO Audit", d: "We identify and fix technical issues that impact your rankings, including crawl errors, Core Web Vitals, indexing, schema markup, site architecture, and much more." },
      { t: "Keyword Architecture", d: "A strategic keyword plan built around high-value search terms and user intent, ensuring your content reaches customers at every stage of their buying journey." },
      { t: "On-Page & Content", d: "Optimize every page with strategic content, metadata, internal linking, and on-page enhancements that improve rankings and user experience." },
      { t: "Off-Page SEO & Link Building", d: "Strengthen your website's authority through ethical link building, digital PR, guest posting, brand mentions, and high-quality backlink acquisition." },
      { t: "Local SEO & Google Business Profile", d: "Improve local visibility with Google Business Profile optimization, citation management, location pages, reviews, and hyperlocal SEO strategies." },
      { t: "Performance Tracking & Reporting", d: "Track rankings, organic traffic, conversions, and business growth with transparent reporting, actionable insights, and continuous optimization." },
    ],
    faqs: [
      { q: "How long before I see results from SEO?", a: "SEO is a long-term strategy. Most businesses start seeing improvements in keyword rankings and organic traffic within 3–6 months, depending on their industry, competition, and website's current SEO performance." },
      { q: "Do you guarantee first-page Google rankings?", a: "No ethical SEO agency can guarantee first-page or #1 Google rankings. We focus on proven SEO strategies, including technical SEO, on-page SEO, off-page SEO, and content optimization to deliver sustainable organic growth." },
      { q: "What is included in your SEO services?", a: "Our SEO services include technical SEO audits, keyword research, on-page SEO, off-page SEO, content optimization, local SEO, Google Business Profile optimization, link building, and monthly performance reporting." },
      { q: "How do you measure SEO success?", a: "We measure SEO success through improvements in keyword rankings, organic traffic, qualified leads, conversions, Google Business Profile performance, and overall return on investment—not just search engine rankings." },
    ],
  },
  {
    hero_position: "35% 50%",
    slug: "paid-ads",
    n: "02",
    title: "Paid Advertising",
    short: "Paid Ads",
    tagline: "Predictable growth on Google, Meta & YouTube.",
    intro:
      "Creative testing systems, audience iteration, and scaling playbooks that turn ad spend into predictable revenue. We treat paid as an engineering problem: hypothesis → test → measure → scale.",
      sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "Paid Ads",
    titleEnd: "Playbook.",
    description:
      "From Google Ads and Meta Ads to landing page optimization, conversion tracking, remarketing, and performance reporting, we build paid advertising campaigns focused on measurable business growth."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "Paid Ads",
    accent: "Questions",
    titleEnd: "?",
    description:
      "Find answers about Google Ads, Meta Ads, budgets, campaign management, reporting, optimization, and how we scale profitable advertising campaigns."
  }
},
    hero_image:
      "https://images.unsplash.com/photo-1746014601552-4ed3d01da7e8?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    portfolio_tags: ["Meta Ads", "Google Ads", "Paid Media", "LinkedIn"],
    offer: [
      { t: "Google Ads", d: "Search, Shopping, Performance Max, and remarketing campaigns built to drive qualified leads and profitable growth." },
      { t: "Meta Ads Management", d: "Scale your business with Facebook and Instagram Ads using advanced audience targeting, creative testing, and continuous campaign optimization." },
      { t: "YouTube & Display Ads", d: "Increase brand awareness and generate demand through YouTube Ads, Google Display Network, and Demand Gen campaigns." },
      { t: "Landing Page Optimization", d: "Conversion-focused landing pages designed to turn more visitors into leads, customers, and revenue." },
      { t: "Conversion Tracking & Analytics", d: "Measure every click, lead, and sale with GA4, Google Tag Manager, Meta Pixel, enhanced conversions, and performance dashboards." },
      { t: "Remarketing & Performance Optimization", d: "econnect with interested users through remarketing campaigns while continuously optimizing bids, audiences, creatives, and ROAS." },
    ],
    faqs: [
  {
    q: "Which advertising platforms do you manage?",
    a: "We manage Google Ads, Meta Ads (Facebook & Instagram), YouTube Ads, Display Ads, Performance Max campaigns, and LinkedIn Ads. We recommend the right platform based on your industry, target audience, and business goals."
  },
  {
    q: "How much should I budget for Google Ads or Meta Ads?",
    a: "Every business is different, but we generally recommend starting with a budget that allows enough data for optimization. After understanding your goals, competition, and target market, we'll recommend an advertising budget designed to maximize ROI."
  },
  {
    q: "How long does it take to see results from paid advertising?",
    a: "Unlike SEO, paid advertising can start generating traffic and leads almost immediately after launch. We continuously optimize campaigns during the first few weeks to improve click-through rates, conversion rates, and return on ad spend."
  },
  {
    q: "How do you measure the success of a paid advertising campaign?",
    a: "We track the metrics that matter most to your business, including leads, sales, cost per acquisition (CPA), return on ad spend (ROAS), conversion rate, and overall campaign profitability through detailed monthly reporting."
  },
]
  },
  {
    slug: "web-and-app-development",
    n: "03",
    title: "Website & App Development",
    short: "Web & App Dev",
    tagline: "Editorial builds. Conversion-tuned.",
    intro:
      "Editorial marketing sites, Shopify commerce, and mobile apps built for both story-telling and conversion. We design and build in-house, ship weekly, and hand over a system you can actually run.",
      sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "Development",
    titleEnd: "Process.",
    description:
      "From business websites and eCommerce stores to custom web applications and mobile apps, we design and develop fast, scalable, SEO-friendly digital products that deliver exceptional user experiences and measurable business growth."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "Development",
    accent: "Questions",
    titleEnd: "?",
    description:
      "Learn more about our website and app development process, timelines, technology stack, pricing, maintenance, and post-launch support."
  }
},
    hero_image:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1600",
    portfolio_tags: ["Website", "Shopify", "App", "Development", "Web"],
    offer: [
  {
    t: "Business Website Development",
    d: "Professional, responsive business websites designed to build credibility, improve user experience, and generate more leads across every device."
  },
  {
    t: "eCommerce Development",
    d: "Custom Shopify and WooCommerce stores built for seamless shopping experiences, higher conversions, secure payments, and scalable online growth."
  },
  {
    t: "Custom Web Applications",
    d: "Develop powerful web applications, customer portals, dashboards, and business management systems tailored to your unique workflows."
  },
  {
    t: "Mobile App Development",
    d: "Build intuitive Android and iOS applications with modern UI, high performance, and seamless user experiences for startups and growing businesses."
  },
  {
    t: "UI/UX Design & CMS Integration",
    d: "User-focused interface design combined with easy-to-manage content management systems, giving your team complete control over website updates."
  },
  {
    t: "Website Optimization & Maintenance",
    d: "Improve website speed, Core Web Vitals, SEO performance, security, backups, and ongoing maintenance to keep your digital presence running smoothly."
  },
],
   faqs: [
  {
    q: "How long does it take to build a website?",
    a: "Project timelines depend on complexity. Most business websites are completed within 4–8 weeks, while custom web applications and mobile apps may take longer depending on the required features and integrations."
  },
  {
    q: "Do you build SEO-friendly websites?",
    a: "Yes. Every website is developed with SEO best practices, including fast loading speeds, mobile responsiveness, clean code, Core Web Vitals optimization, structured data, and search engine-friendly architecture."
  },
  {
    q: "Can you redesign my existing website?",
    a: "Absolutely. We can modernize your existing website, improve performance, enhance user experience, strengthen your branding, and optimize it for higher conversions without losing your existing content or SEO value."
  },
  {
    q: "Do you provide website maintenance and support after launch?",
    a: "Yes. We offer ongoing maintenance, security updates, performance monitoring, backups, feature enhancements, and technical support to ensure your website or application continues to perform at its best."
  },
],
  },
  {
    slug: "graphic-design",
    n: "04",
    title: "Graphic Design",
    short: "Graphic Design",
    tagline: "Craft you can feel.",
    intro:
      "Brand identity, campaign design, packaging, and social visuals that make people stop and look. We treat design as a strategic lever — not decoration.",
      sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "Design",
    titleEnd: "Studio.",
    description:
      "From branding and visual identity to marketing creatives, packaging, social media graphics, print collateral, and motion design, we create visuals that make your brand memorable."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "Need",
    accent: "Answers ",
    titleEnd: "?",
    description:
      "Learn more about our graphic design services, branding process, revisions, deliverables, timelines, and source files."
  }
},
    hero_image:
      "https://images.unsplash.com/photo-1609619385002-f40f1df9b7eb?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    portfolio_tags: ["Branding", "Design", "Photography", "Content"],
    offer: [
  {
    t: "Brand Identity & Logo Design",
    d: "Build a memorable brand with custom logo design, color palettes, typography, brand guidelines, and complete visual identity systems that create lasting recognition across digital and print platforms."
  },
  {
    t: "Social Media & Marketing Creatives",
    d: "Eye-catching social media posts, ad creatives, banners, carousel designs, thumbnails, and promotional graphics designed to increase engagement, brand awareness, and conversions."
  },
  {
    t: "Packaging & Print Design",
    d: "Professional packaging design, brochures, flyers, business cards, catalogs, menus, product labels, and other print marketing materials that strengthen your brand presence."
  },
  {
    t: "UI Graphics & Website Visual Design",
    d: "Modern website graphics, landing page visuals, UI assets, icons, illustrations, and digital design elements that improve user experience and reinforce your brand identity."
  },
  {
    t: "Motion Graphics & Video Creatives",
    d: "Animated social media content, motion graphics, product explainers, promotional videos, and Reels designed to capture attention and increase audience engagement."
  },
  {
    t: "Presentation & Corporate Design",
    d: "Professionally designed sales presentations, investor pitch decks, company profiles, proposals, and corporate documents that communicate your business with clarity and impact."
  },
],
   faqs: [
  {
    q: "What graphic design services do you offer?",
    a: "We provide complete graphic design services including logo design, brand identity, social media creatives, marketing materials, packaging design, print collateral, presentation design, motion graphics, and custom digital assets tailored to your business."
  },
  {
    q: "Can you design a logo without a complete branding package?",
    a: "Yes. We offer standalone logo design services as well as complete brand identity packages. However, we recommend a full branding system—including colors, typography, and brand guidelines—to ensure consistency across all marketing channels."
  },
  {
    q: "How many revisions are included in a design project?",
    a: "Our design process includes concept presentation followed by two structured revision rounds to refine the selected direction. Additional revisions can be accommodated if required to ensure you're completely satisfied with the final result."
  },
  {
    q: "Will I receive the editable source files?",
    a: "Yes. Upon project completion, you'll receive all approved source files in formats such as AI, PSD, Figma, PDF, SVG, PNG, and other required file types, along with brand guidelines where applicable."
  },
]
  },
  {
    slug: "social-media",
    n: "05",
    title: "Social Media",
    short: "Social Media",
    tagline: "Signature content. Real community.",
    intro:
      "Signature content pillars, hook frameworks, and community building for Instagram, LinkedIn, and YouTube Shorts. Content that sounds like you — and drives real business outcomes.",
    sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "Social Media",
    titleEnd: "Strategy.",
    description:
      "From content strategy and short-form videos to community management, platform growth, analytics, and performance reporting, we create social media systems that build audiences and drive business results."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "Social Media",
    accent: "Decoded",
    titleEnd: ".",
    description:
      "Learn about our social media management services, content creation process, posting frequency, reporting, and how we help brands grow across today's leading platforms."
  }
},
    hero_image:
      "https://images.unsplash.com/photo-1724862936518-ae7fcfc052c1?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    portfolio_tags: ["Social Media", "Content", "Photography", "Meta Ads"],
    offer: [
  {
    t: "Social Media Strategy & Content Planning",
    d: "Build a results-driven social media strategy with content pillars, audience research, posting calendars, competitor analysis, and a consistent brand voice across every platform."
  },
  {
    t: "Reels, Shorts & Video Content Creation",
    d: "Create engaging Instagram Reels, YouTube Shorts, Facebook videos, and short-form content optimized to increase reach, engagement, and audience growth."
  },
  {
    t: "Instagram & Facebook Management",
    d: "Professional social media management including feed design, captions, Stories, carousel posts, hashtag strategy, and audience engagement to grow your online presence."
  },
  {
    t: "LinkedIn Personal Branding",
    d: "Position founders, executives, and professionals as industry leaders with strategic LinkedIn content, profile optimization, thought leadership, and lead-generating posts."
  },
  {
    t: "Community Management & Engagement",
    d: "Build stronger customer relationships through comment moderation, direct message management, audience engagement, and proactive community building across social platforms."
  },
  {
    t: "Performance Analytics & Reporting",
    d: "Track reach, engagement, follower growth, conversions, and campaign performance with detailed monthly reporting and continuous content optimization."
  },
],
faqs: [
  {
    q: "What social media management services do you offer?",
    a: "We provide end-to-end social media management services including content strategy, graphic design, video editing, Instagram and Facebook management, LinkedIn marketing, community management, analytics, and monthly performance reporting."
  },
  {
    q: "Which social media platforms do you manage?",
    a: "We manage Instagram, Facebook, LinkedIn, YouTube, X (Twitter), and other major social media platforms. We recommend the right channels based on your business goals and target audience."
  },
  {
    q: "Do you create original content for social media?",
    a: "Yes. Our team creates original graphics, reels, short-form videos, captions, carousels, and branded content tailored to your business while maintaining a consistent brand voice and visual identity."
  },
  {
    q: "How do you measure social media success?",
    a: "We measure performance through key metrics such as reach, engagement, follower growth, website traffic, leads, conversions, and return on investment. You'll receive detailed reports with actionable insights every month."
  },
],
  },
  {
    slug: "whatsapp-marketing",
    n: "06",
    title: "WhatsApp Marketing",
    short: "WhatsApp",
    tagline: "The most-read inbox on earth.",
    intro:
      "Compliant broadcasts, cart-recovery flows, and chatbot journeys on WhatsApp Business API. The most-read inbox on the planet — used the way it should be.",
    sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "WhatsApp",
    titleEnd: "Solutions.",
    description:
      "From WhatsApp Business API setup and chatbot automation to broadcast campaigns, customer support, CRM integrations, and analytics, we help businesses turn conversations into conversions."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "WhatsApp",
    accent: "Explained",
    titleEnd: ".",
    description:
      "Everything you need to know about WhatsApp Business API, chatbot automation, broadcast messaging, pricing, integrations, compliance, and campaign management."
  }
},
    hero_image:
      "https://images.unsplash.com/photo-1633354931133-27ac1ee5d853?q=80&w=1180&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    portfolio_tags: ["WhatsApp", "CRM", "Lifecycle", "Messaging"],
   offer: [
  {
    t: "WhatsApp Business API Setup",
    d: "Complete WhatsApp Business API setup, Meta verification, number onboarding, and account configuration to help your business communicate securely and at scale."
  },
  {
    t: "Broadcast Messaging Campaigns",
    d: "Create and manage targeted WhatsApp broadcast campaigns using approved message templates, audience segmentation, and performance tracking to increase engagement and conversions."
  },
  {
    t: "WhatsApp Chatbot Automation",
    d: "Automate customer support, lead qualification, FAQs, appointment booking, and sales conversations with intelligent WhatsApp chatbot solutions."
  },
  {
    t: "Abandoned Cart Recovery & Sales Automation",
    d: "Recover lost sales with automated cart recovery messages, order updates, promotional campaigns, and personalized customer journeys for Shopify and WooCommerce."
  },
  {
    t: "CRM & Business System Integration",
    d: "Integrate WhatsApp with HubSpot, Zoho CRM, Salesforce, Shopify, WooCommerce, and custom business applications for seamless customer communication."
  },
  {
    t: "Analytics, Reporting & Optimization",
    d: "Track message delivery, read rates, customer engagement, conversions, and campaign performance with detailed reporting and continuous optimization."
  },
],
faqs: [
  {
    q: "What is WhatsApp Business API and who is it for?",
    a: "WhatsApp Business API is designed for growing businesses that want to automate customer communication, send broadcast messages, integrate with CRMs, and manage high volumes of conversations while remaining compliant with Meta's policies."
  },
  {
    q: "Can you set up WhatsApp Business API for my business?",
    a: "Yes. We handle the complete WhatsApp Business API setup process, including Meta Business verification, phone number onboarding, message template approval, chatbot configuration, and CRM integration."
  },
  {
    q: "Can WhatsApp Marketing generate more leads and sales?",
    a: "Absolutely. WhatsApp Marketing helps businesses increase customer engagement, recover abandoned carts, nurture leads, send promotional campaigns, and provide instant customer support, leading to higher conversion rates."
  },
  {
    q: "Can WhatsApp integrate with my CRM or eCommerce platform?",
    a: "Yes. We integrate WhatsApp Business API with HubSpot, Zoho CRM, Salesforce, Shopify, WooCommerce, and other business tools to automate customer communication and streamline sales workflows."
  },
],
  },
  {
    slug: "email-marketing",
    n: "07",
    title: "Email Marketing",
    short: "Email",
    tagline: "The channel that quietly compounds.",
    intro:
      "Lifecycle flows, newsletter systems, and deliverability engineering that turn cold leads into repeat customers. The channel with the highest ROI, done properly.",
    sectionContent: {
  offer: {
    eyebrow: "What we offer",
    titleStart: "Our",
    accent: "Email Marketing",
    titleEnd: "Solutions.",
    description:
      "From email strategy and automation to newsletters, audience segmentation, deliverability optimization, and analytics, we create email marketing campaigns that nurture leads, increase customer retention, and drive consistent revenue."
  },

  faq: {
    eyebrow: "Frequently Asked Questions",
    titleStart: "email",
accent: "Marketing ",
titleEnd: " ?",
    description:
      "Learn how email marketing, automation, segmentation, newsletters, and lifecycle campaigns can help you generate more leads, retain customers, and increase sales."
  }
},
    hero_image:
      "https://images.unsplash.com/photo-1556204975-1851fadab092?q=80&w=1772&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    portfolio_tags: ["Email", "Lifecycle", "CRM", "Content"],
   offer: [
  {
    t: "Email Marketing Strategy & Automation",
    d: "Develop high-converting email marketing strategies with automated customer journeys, audience segmentation, and personalized campaigns that increase engagement and revenue."
  },
  {
    t: "Email Automation & Lifecycle Campaigns",
    d: "Create automated welcome emails, abandoned cart recovery, post-purchase follow-ups, win-back campaigns, and lead nurturing sequences that convert customers automatically."
  },
  {
    t: "Newsletter Design & Content Creation",
    d: "Design visually engaging email newsletters with compelling copy, branded layouts, and strong calls-to-action that improve open rates and customer retention."
  },
  {
    t: "Audience Segmentation & Personalization",
    d: "Segment subscribers based on customer behavior, purchase history, and engagement to deliver highly personalized email campaigns that maximize conversions."
  },
  {
    t: "Email Deliverability & Platform Management",
    d: "Improve inbox placement with SPF, DKIM, DMARC configuration, list hygiene, sender reputation management, and expert support for Klaviyo, Mailchimp, HubSpot, and other leading platforms."
  },
  {
    t: "Campaign Analytics & Performance Optimization",
    d: "Monitor open rates, click-through rates, conversions, revenue, and subscriber growth with detailed reporting and continuous A/B testing to improve campaign performance."
  },
],
faqs: [
  {
    q: "What email marketing services do you provide?",
    a: "We provide complete email marketing services including strategy, campaign creation, newsletter design, automation workflows, audience segmentation, deliverability optimization, A/B testing, and monthly performance reporting."
  },
  {
    q: "Which email marketing platforms do you support?",
    a: "We work with Klaviyo, Mailchimp, HubSpot, Brevo, ActiveCampaign, MailerLite, and other leading email marketing platforms. We recommend the right solution based on your business goals."
  },
  {
    q: "Can you automate my email marketing campaigns?",
    a: "Yes. We build automated email workflows including welcome sequences, abandoned cart recovery, lead nurturing, post-purchase emails, customer re-engagement campaigns, and personalized lifecycle journeys."
  },
  {
    q: "How do you measure the success of email marketing?",
    a: "We track key performance metrics such as open rates, click-through rates, conversions, revenue generated, subscriber growth, unsubscribe rates, and overall return on investment to continuously improve campaign performance."
  },
],
  },
];

export const serviceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
